module.exports = __webpack_public_path__ + "static/img/hz.52d0318.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/relation/hz.png
// module id = fMmD
// module chunks = 0